import React from 'react';
import Client from 'App/resources/Model/Client';
import SalesHistory from 'App/components/SalesHistory';

export default function HistoryColumn({
	account,
	createNewAccountRow
}: {
	account: Client;
	createNewAccountRow: boolean;
}) {
	const Component = !createNewAccountRow ? 'div' : 'td';

	return (
		<Component className={`DataSourceColumn history ${!createNewAccountRow ? 'align-items-center' : ''}`}>
			<SalesHistory entity={account} entityName={'client'} />
		</Component>
	);
}
